<script setup>
import BaseModal from "../../global/modals/BaseModal.vue";
import axios from "axios";
import SweetToast from "../../../SweetToast";
import {useMutation, useQueryClient} from "@tanstack/vue-query";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const props = defineProps({
  apiKey: {
    required: true,
    type: Object,
  }
});

const emit = defineEmits(['close']);
const queryClient = useQueryClient()

const {mutate: deleteApiKey, isPending} = useMutation({
  mutationFn: async () => await axios.delete(`/ajax/v2/api-keys/${props.apiKey.id}`),
  onSuccess: () => {
    SweetToast.fire({
      icon: 'success',
      title: `The API Key ${props.apiKey.name} has been deleted.`,
    });

    queryClient.invalidateQueries({ queryKey: ['api-keys'] })
    emit('close')
  },
  onError: () => {
    SweetToast.fire({
      icon: 'error',
      title: 'There was an error deleting your API Key',
    });

    emit('close')
  },
})
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal @close="$emit('close')">
      <template #heading>
        Delete API Key?
      </template>
      <div class="tw-min-w-[500px]">
        <p class="tw-my-6 tw-text-center">
          Are you sure you wish to do this? This action cannot be undone.
        </p>
      </div>
      <template #footer>
        <div class="tw-w-full tw-flex tw-justify-center tw-gap-2 tw-m-0">
          <DefaultButton
            class="tw-bg-matterhorn hover:tw-bg-matterhorn-dark tw-rounded-lg tw-px-8 tw-py-5"
            size="auto"
            @click="$emit('close')"
          >
            No Thanks
          </DefaultButton>
          <DefaultButton
            class="!tw-bg-denali hover:!tw-bg-denali-dark tw-rounded-lg tw-px-8 tw-py-5"
            size="auto"
            :disabled="isPending"
            @click="deleteApiKey"
          >
            <svg-vue
              v-if="isPending"
              class="tw-h-4 tw-mr-2"
              icon="icons/loading"
            />
            {{ isPending ? 'Deleting' : 'Delete Key' }}
          </DefaultButton>
        </div>
      </template>
    </BaseModal>
  </Teleport>
</template>

